import React from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import EconomicSection from "../components/EconomicSection";
import WhatYouGet from "../components/WhatYouGet";
import FrameworkSection from "../components/FrameworkSection";
import BusinessPreview from "../components/BusinessPreview";
import MarketData from "../components/MarketData";
import Purchase from "../components/Purchase";
import FAQ from "../components/FAQ";import LatestInsights from "../components/LatestInsights";
import Footer from "../components/Footer";
import { useSEO } from "../hooks/useSEO";

const LandingPage = () => {
  useSEO(
    "Mortgage Servicing Early-Intervention Framework | Mortgage Survival Playbook 2026",
    "An institutional early-intervention framework for mortgage servicers, banks, and credit unions to identify emerging borrower risk earlier, standardize intervention, and measure outcomes. $4,995 institutional license by Lloyd Igbokwe."
  );
  return (
  <>
    <Nav />
    <Hero />
    <EconomicSection />
    <FrameworkSection />
    <WhatYouGet />
    <BusinessPreview />
    <MarketData />
    <Purchase />
    <FAQ />
    <LatestInsights />
    <section className="section bg1">
      <div className="w">
        <div style={{ maxWidth: 760 }}>
          <div className="eyebrow">About the Author</div>
          <h2 className="h2">About the <em className="gold">Author</em></h2>
          <p style={{ fontSize: "1rem", color: "var(--g1)", lineHeight: 1.8, marginTop: "1rem" }}>
            Lloyd Igbokwe is the founder and creator of the Mortgage Survival Playbook 2026 (ENVOLVP LLC, Houston, Texas). He developed the framework through extensive analysis of ATTOM U.S. foreclosure market data, Mortgage Bankers Association delinquency surveys, and CFPB Regulation X servicing requirements, translating them into a practical institutional implementation resource. The Playbook is updated as new market data is published, and every licensee receives 90 days of direct email implementation support.
          </p>
          <p style={{ marginTop: "1.2rem" }}>
            <a href="/about" style={{ color: "var(--gold)", textDecoration: "none", fontWeight: 600 }} data-testid="read-full-profile">Read Lloyd's full profile →</a>
          </p>
          <p style={{ fontSize: "0.95rem", color: "var(--gold)", marginTop: "1.5rem" }}>
            <strong>Contact:</strong>{" "}
            <a href="mailto:hello@mortgagesurvivalplaybook.com" style={{ color: "var(--gold)", textDecoration: "underline" }}>hello@mortgagesurvivalplaybook.com</a>
          </p>
        </div>
      </div>
    </section>
    <Footer />
  </>
  );
};

export default LandingPage;
